import {Pipe, PipeTransform} from "@angular/core";
import {User} from "../../authentication/authentication.service";
import {AssignedDekraEmployee} from "../../store/state/order.state";

@Pipe({
    name: 'fullNameDisplay',
    standalone: false
})
export class FullNameDisplayPipe implements PipeTransform {

	transform(user: User | AssignedDekraEmployee): string {
		return user == null ? '' : `${user.firstName} ${user.lastName}`;
	}
}
